import React from "react";
import NestedPage from "../../components/navigation/NestedPage";
import { nestedGroups } from "../../config/navigation";

const ControlPanel: React.FC = () => {
  const controlPanelGroup = nestedGroups.find(
    (group) => group.id === "controlpanel"
  );

  if (!controlPanelGroup) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-gray-500">Control Panel group not found.</p>
      </div>
    );
  }

  return <NestedPage group={controlPanelGroup} />;
};

export default ControlPanel;
